module["exports"] = [
  "###-####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ja/address/postcode.js
 ** module id = 706
 ** module chunks = 0
 **/